import styled from 'styled-components'

export const SliderMenu = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${ (props) => props.theme.colors['hintergrund-allgemein'] };

  .menu-label {
    opacity: 0.57;
    font-size: 16px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: center;
    color: ${ (props) => props.theme.colors['standard-schwarz'] };
  }

  .menu-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 15px 40px;

    .item {
      width: 20px;
      height: 20px;
      border-radius: 2px;
      margin: 0 5px;
      cursor: pointer;

      background-color: grey;

      &.active {
        background-color: ${ (props) => props.theme.colors['aok-gruen'] };
      }
    }
  }
`
